import React from "react"
import styled from "styled-components"
import {StaticImage} from "gatsby-plugin-image"
import { Section, SectionDescription, SectionTitle, SectionImageBkg, ExploreMore} from "../Section"
import WhiteButton from "../Button/WhiteButton"

const SectionImageBkgs = styled(SectionImageBkg)`    
    width:100%;   
    left:0;
    @media (min-width: 768px) {
        left:auto;
        right:0;
        width:100%;   

    }
`
const HeroBackground = styled.div`    
    display: flex;
    align-items: center;
    height: 100%;
    clip-path: ellipse(calc(100% + 120px) 100% at 50% 0);
    @media (min-width: 768px) {
        clip-path: ellipse(100% 100% at 0% 50%);
    }
    .gatsby-image-wrapper{
        height:100%;
    }
    /* &:before{
		content: "";
		position: absolute;
        width:100%;
		height:100%;
        top:0;
        left:0;
        clip-path: ellipse(calc(100% + 120px) 100% at 50% 0);
        @media (min-width: 768px) {
            clip-path: ellipse(100% 100% at 0% 50%);
        }
	}*/
    &:before{
		background-color:#fff;
	}	 
    > img{
        position: relative;
    }
`
const ContentGrid = styled.div`
    position: relative;
    @media (min-width: 768px) {
        display: grid;
        align-items:self;
        grid-template-columns: 1.2fr 2fr;
    }
`
const LeftGrid = styled.div`
    position: relative;    
    padding:0;
    /* padding: 30px 15px 0 15px;
    @media (min-width: 992px) {
        padding: 40px 30px 0 30px;
    }
    @media (min-width: 1200px) {
        padding: 60px 30px 0 30px;
    }
    @media (min-width: 1600px) {
        padding: 90px 60px 0 calc(50vw - 685px);
    } */
`
const RightGrid = styled.div`
    position: relative;
    padding: 30px 15px;
    @media (min-width: 992px) {
        padding: 40px 30px 40px 30px;  
    }
    @media (min-width: 1200px) {
        padding: 60px 30px 60px 30px;  
    }
    @media (min-width: 1600px) {
        padding: 90px calc(50vw - 685px) 90px 60px;  
    }
`
const ExploreMores = styled(ExploreMore)`
    @media(min-width:768px){
        justify-content:left;
    }
`

const DesignSection = () => {
	return(
        <Section bgColor="#E9242A" className="section-design">
            <SectionImageBkgs opacity="0.6"><StaticImage src="../../images/design-bg.jpg" alt="design-bg" /></SectionImageBkgs>
            <ContentGrid>
                <LeftGrid>
                    <HeroBackground>
                        <StaticImage src="../../images/design-icon.png" alt="design-icon" />
                    </HeroBackground>
                </LeftGrid>
                <RightGrid>
                    <SectionTitle mb="20px" color="#fff">Custom Design & Price Your Building </SectionTitle>
                    <SectionDescription mb="30px" color="#fff">
                        <p>Our 3D Design Tool lets you customize the structure according to your specifications. You can add doors, windows, insulation, change the colors of walls, roofs, and trims, and even get real-time pricing. Get started today! </p>
                    </SectionDescription>
                    <ExploreMores className="design-btn"><a href="https://engineeredmetalbuildings.sensei3d.com/" target="_blank" rel="noreferrer" aria-label="Design Your Building Today" ><WhiteButton text="Design Your Building Today"/></a></ExploreMores>
                </RightGrid>
            </ContentGrid>
        </Section>
	)
}

export default DesignSection